import { defineStore } from "pinia";
import { ref } from "vue";
import {
  PaginatedLoadState,
  State,
  stateError,
  stateInitial,
  stateLoaded,
  stateLoading,
} from "@/store/loadingStates";
import {
  type CourseCompletionsTypes,
  CourseCompletions,
} from "@inctec/elearning-ui-client";

type SearchBody = {
  page: number;
  pageSize: number;
  userId: number;
  search: string;
};

export const useCourseCompletionStore = defineStore("courseCompletions", () => {
  const completionsLoadingState = ref<
    PaginatedLoadState<CourseCompletionsTypes.Completion[]>
  >({
    ...stateInitial,
    result: [],
    query: undefined,
  });

  async function loadCompletions(query: {
    page: number;
    pageSize: number;
    userId: number;
    search: string;
  }) {
    completionsLoadingState.value = {
      ...completionsLoadingState.value,
      ...stateLoading,
    };
    const response = await CourseCompletions.searchCourseCompletions({
      body: {
        page: query.page,
        pageSize: query.pageSize,
        state: ["revoked", "recognised"],
        users: [query.userId],
        ...(query.search === "" ? {} : { q: query.search }),
      },
    })
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        completionsLoadingState.value = {
          ...stateError,
          result: [],
          query: undefined,
        };
        throw e;
      });

    completionsLoadingState.value = { ...stateLoaded, ...response, query };
  }

  function reloadCompletions() {
    if (completionsLoadingState.value.query !== undefined) {
      void loadCompletions(completionsLoadingState.value.query);
    }
  }

  function reset() {
    completionsLoadingState.value = {
      ...stateInitial,
      result: [],
      query: undefined,
    };
  }

  return {
    loadCompletions,
    completionsLoadingState,
    reloadCompletions,
    reset,
  };
});
